<template>
  <div v-if="translations">
    <v-navigation-drawer
      app
      v-model="drawer"
      :fixed="$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      :permanent="$vuetify.breakpoint.mdAndUp"
      tag="header"
      color="blue"
      class="navigation"
    >
      <button
        aria-label="close menu"
        class="navigation__close"
        @click="drawer = false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          class="navigation__close-icon"
        >
          <path
            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            fill="white"
          />
        </svg>
      </button>

      <div class="navigation__head">
        <v-img
          src="@/assets/images/logo.png"
          contain
          width="60"
          alt="Camden Pocket PA"
          class="navigation__logo"
        />
      </div>

      <v-list nav dense class="navigation__list">
        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'home' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.home }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'infoandadvice' }"
            class="navigation__nav-item-link"
          >
            {{ translations.home.labels.infoAndAdvice }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'organisations_archive' }"
            class="navigation__nav-item-link"
          >
            {{ translations.home.labels.helpfulOrganisations }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'education_training_and_employment' }"
            class="navigation__nav-item-link"
          >
            {{ translations.home.labels.workAndOpportunities }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'events_and_activities' }"
            class="navigation__nav-item-link"
          >
            {{ translations.home.labels.eventsAndActivities }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'offers_archive' }"
            class="navigation__nav-item-link"
          >
            {{ translations.home.labels.discountsAndOffers }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'budget_planner' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.budgetPlanner }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'toolkit' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.mentalHealthHub }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'posts' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.posts }}
          </RouterLink>
        </v-list-item>

        <!-- <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'chats' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.messaging }}
            <span
              v-if="isTokenSet && totalUnreadMessages"
              class="messages-notification"
            >
              <v-icon color="primary" large class="pa-0">mdi-chat</v-icon>
              <span class="messages-notification__count">
                {{ totalUnreadMessages }}
              </span>
            </span>
          </RouterLink>
        </v-list-item> -->

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'surveys' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.surveys }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'vips' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.vips }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink
            :to="{ name: 'contact' }"
            class="navigation__nav-item-link"
            exact
          >
            {{ translations.home.labels.getInTouch }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--link"
        >
          <RouterLink :to="{ name: 'legal' }" class="navigation__nav-item-link">
            {{ translations.home.labels.legal }}
          </RouterLink>
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--settings"
        >
          <Settings />
        </v-list-item>

        <v-list-item
          class="navigation__nav-list-item navigation__nav-list-item--language"
        >
          <v-list-item-title
            class="navigation__nav-item-title navigation__nav-item-title--language"
          >
            <label for="language-select">
              {{ translations.settings.text.languages }}
            </label>
          </v-list-item-title>

          <v-select
            v-model="selectedLang"
            :items="langs"
            menu-props="auto"
            name="langs"
            item-text="name"
            item-value="code"
            solo
            flat
            hide-details
            append-icon="mdi-chevron-down"
            id="language-select"
            class="select-input select-input--white"
            @change="languageChangeHandler"
          />
        </v-list-item>

        <v-list-item>
          <button
            type="button"
            class="btn btn--full-width btn--blue-text"
            @click="restartTheTour"
          >
            {{ translations.tutorial.startTutorial }}
          </button>
        </v-list-item>

        <v-list-item v-if="isTokenSet" class="sign-out px-2 py-4">
          <v-divider />

          <button
            type="button"
            class="btn btn--full-width btn--blue-text"
            @click="logoutBtnClickHandler"
          >
            {{ translations.home.labels.logout }}
          </button>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :class="[
        'toolbar',
        {
          'toolbar--shape-background': shapeBackground,
        },
      ]"
      light
      tag="div"
      fixed
    >
      <svg
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <clipPath id="responsiveClipPath" clipPathUnits="objectBoundingBox">
            <path
              d="
        M0,0 
        H1 
        V0 
        C1,0.1445,0.9842,0.27015,0.9619,0.30382 
        L0.5117,0.98199 
        C0.5041,0.9938,0.4959,0.9938,0.4883,0.98199 
        L0.0381,0.30382 
        C0.0158,0.27015,0,0.1445,0,0 
        V0 Z"
            />
          </clipPath>
        </defs>
      </svg>

      <div v-if="shapeBackground" class="toolbar__clip-container">
        <div class="toolbar__clipped-content"></div>
      </div>

      <div class="toolbar__content-inner">
        <div class="toolbar__inner">
          <v-app-bar-nav-icon
            @click="toggleDrawer"
            id="menu-btn"
            class="toolbar__btn hidden-md-and-up"
            :aria-label="translations.accessibility.openMenu"
          >
            <svg
              width="24"
              height="20"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M0 2C0 0.89544 0.895432 0 2 0H22C23.1046 0 24 0.89544 24 2C24 3.10456 23.1046 4 22 4H2C0.895429 4 0 3.10456 0 2Z"
                fill="white"
              />
              <path
                d="M0 10C0 8.89544 0.895432 8 2 8H14C15.1046 8 16 8.89544 16 10C16 11.1046 15.1046 12 14 12H2C0.895429 12 0 11.1046 0 10Z"
                fill="white"
              />
              <path
                d="M0 18C0 16.8954 0.895432 16 2 16H22C23.1046 16 24 16.8954 24 18C24 19.1046 23.1046 20 22 20H2C0.895429 20 0 19.1046 0 18Z"
                fill="white"
              />
            </svg>
          </v-app-bar-nav-icon>

          <v-btn
            v-if="$route.name !== 'home'"
            icon
            :aria-label="translations.tutorial.buttons.back"
            class="toolbar__btn"
            @click="$router.go(-1)"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M14.2 0H5.8C2.2 0 0 2.2 0 5.8V14.2C0 17.8 2.2 20 5.8 20H14.2C17.8 20 20 17.8 20 14.2V5.8C20 2.2 17.8 0 14.2 0ZM11.8 13C12.1 13.3 12.1 13.8 11.8 14.1C11.7 14.2 11.5 14.3 11.3 14.3C11.1 14.3 10.9 14.2 10.8 14.1L7.3 10.6C7 10.3 7 9.8 7.3 9.5L10.8 6C11.1 5.7 11.6 5.7 11.9 6C12.2 6.3 12.2 6.8 11.9 7.1L8.9 10.1L11.8 13Z"
                fill="white"
              />
            </svg>
          </v-btn>

          <v-toolbar-title
            v-if="$route.name === 'infoandadvice'"
            class="toolbar__title"
          >
            {{ translations.home.labels.info }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn
            :to="{ name: 'home' }"
            icon
            aria-label="Open Home page"
            exact
            class="toolbar__btn"
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.07813 0.615578C9.27773 -0.205193 10.8582 -0.205193 12.0578 0.615578L18.602 5.09317C19.562 5.75 20.1359 6.83822 20.1359 8.00141V16.4762C20.1359 18.4223 18.5583 20 16.6121 20H3.52379C1.57765 20 0 18.4223 0 16.4762V8.00141C0 6.83822 0.573995 5.75 1.53397 5.09317L8.07813 0.615578ZM7.55097 15.4694C7.27296 15.4694 7.04757 15.6948 7.04757 15.9728C7.04757 16.2508 7.27296 16.4762 7.55097 16.4762H12.585C12.8629 16.4762 13.0884 16.2508 13.0884 15.9728C13.0884 15.6948 12.8629 15.4694 12.585 15.4694H7.55097Z"
                fill="white"
              />
            </svg>
          </v-btn>

          <router-link
            v-if="isTokenSet"
            :to="{ name: 'user_profile' }"
            class="toolbar__avatar"
            :aria-label="translations.dcp.user_account.edit_profile"
          >
            <AvatarIcon
              :avatar="userAvatar"
              :size="28"
              :text-size="14"
              :centered="true"
              background-color="white"
              text-color="primary--text"
            />
          </router-link>

          <v-btn
            :to="{ name: 'favourites' }"
            icon
            aria-label="Open Favourites page"
            class="toolbar__btn"
            id="favourites-btn"
          >
            <span class="class sr-only">Open Favourites page</span>
            <v-badge
              v-if="favouritesCount > 0"
              :content="favouritesCount"
              color="#000000"
              overlap
              class="black--text"
              dark
              bottom
            >
              <svg
                width="25"
                height="21"
                viewBox="0 0 25 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.3873 10.5963L20.4699 12.5137L13.3173 19.6757C12.8756 20.1081 12.1613 20.1081 11.7195 19.6757L4.56691 12.5137L2.64952 10.5963C0.450161 8.41578 0.450161 4.85357 2.64952 2.65422C3.7398 1.55454 5.18724 1 6.63468 1C8.07272 1 9.51076 1.55454 10.601 2.65422L11.7195 3.77269C12.1613 4.21444 12.8756 4.21444 13.3173 3.77269L14.4358 2.65422C15.5261 1.55454 16.9641 1 18.4022 1C19.8496 1 21.2971 1.55454 22.3873 2.65422C24.5867 4.85357 24.5867 8.41578 22.3873 10.5963Z"
                  fill="white"
                  stroke="white"
                />
              </svg>
            </v-badge>
            <svg
              v-else
              width="25"
              height="21"
              viewBox="0 0 25 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.3873 10.5963L20.4699 12.5137L13.3173 19.6757C12.8756 20.1081 12.1613 20.1081 11.7195 19.6757L4.56691 12.5137L2.64952 10.5963C0.450161 8.41578 0.450161 4.85357 2.64952 2.65422C3.7398 1.55454 5.18724 1 6.63468 1C8.07272 1 9.51076 1.55454 10.601 2.65422L11.7195 3.77269C12.1613 4.21444 12.8756 4.21444 13.3173 3.77269L14.4358 2.65422C15.5261 1.55454 16.9641 1 18.4022 1C19.8496 1 21.2971 1.55454 22.3873 2.65422C24.5867 4.85357 24.5867 8.41578 22.3873 10.5963Z"
                fill="white"
                stroke="white"
              />
            </svg>
          </v-btn>

          <v-btn
            :to="{ name: 'search' }"
            icon
            aria-label="Open Search page"
            class="toolbar__btn"
          >
            <v-icon color="white">mdi-magnify</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import Settings from "@/components/Header/Settings.vue";
import AvatarIcon from "@/components/Dcp/AvatarIcon.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Settings,
    AvatarIcon
  },
  name: "Header",
  data: () => ({
    drawer: false,
    selectedLang: localStorage.getItem("current_lang"),
    loading: false,
    alert: false,
    dialog: false,
    fontAlert: false,
    openDyslexic: false,
  }),
  mounted() {
    if (localStorage.getItem("enable_font_change") === "true") {
      this.openDyslexic = true;
    } else {
      this.openDyslexic = false;
    }

    /// listening for language change emit coming form settings.vue
    /// we're passing the 'language' and then setting is as a selected one
    this.$bus.$on("language-changed-from-settings-page", (language) => {
      this.selectedLang = language;
    });
  },
  beforeDestroy() {
    // stop listening for the emit coming from settings.vue
    this.$bus.$off("language-changed-from-settings-page");
  },
  methods: {
    ...mapActions("user", ["logoutUser"]),
    ...mapActions("hubbdata", ["updateLang"]),
    restartTheTour() {
      this.drawer = !this.drawer;
      localStorage.removeItem("has_seen_the_tour");
      this.$router.push({ name: "home" });
      this.$tours["myTour"].start();
    },
    signOut() {
      this.$store.dispatch("signOut").then(() => {
        this.$router.push({ name: "user_sign_in" });
      });
    },
    toggleDrawer() {
      this.drawer = !this.drawer;

      setTimeout(selectMenuItem, 100);
      function selectMenuItem() {
        if (
          document.getElementsByClassName(
            "navigation__nav-item-link router-link-active"
          ).length
        ) {
          document
            .getElementsByClassName(
              "navigation__nav-item-link router-link-active"
            )[0]
            .focus();
        } else {
          document.getElementsByClassName("navigation__close")[0].focus();
        }
      }
    },
    languageChangeHandler() {
      this.updateLang(this.selectedLang);

      this.alert = true;
      // send a global emit back to Settings.vue with the newly selected language
      this.$bus.emit("language-changed-from-header", this.selectedLang);
    },
    DismissAlert() {
      this.alert = false;
    },
    DismissFontAlert() {
      this.fontAlert = false;
    },
    logoutBtnClickHandler() {
      this.logoutUser().then(() => {
        this.$router.push({ name: "sign_in" });
      });
    },
  },
  computed: {
    ...mapGetters("hubbdata", {
      translations: "translations",
      langs: "getLanguages",
    }),
    ...mapGetters("favourites", ["favouritesCount"]),
    ...mapGetters("user", ["isTokenSet", "totalUnreadMessages", "userData"]),
    currentUser() {
      return this.$store.state.user;
    },
    currentLang() {
      let dictionary = {
        en: "English",
        ar: "Arabic",
        zh: "Chinese",
        fr: "French",
        pl: "Polish",
        so: "Somali",
        es: "Spanish",
        vi: "Vietnamese",
      };

      return dictionary[this.selectedLang];
    },
    userAvatar() {
      return {
        avatar_fallback: "#eeeeee",
        image_url: this.userData.image_url,
        display_name: this.userData.display_name,
      };
    },
    shapeBackground() {
      if (
        this.$route.name === "infoandadvice" ||
        this.$route.name === "cms_page" ||
        this.$route.name === "events_archive" ||
        this.$route.name === "offers_archive" ||
        this.$route.name === "offers_article" ||
        this.$route.name === "favourites" ||
        this.$route.name === "legal" ||
        this.$route.name === "legal_information" ||
        this.$route.name === "vips" ||
        this.$route.name === "event_article" ||
        this.$route.name === "events_and_activities" ||
        this.$route.name === "organisations_archive" ||
        this.$route.name === "organisations_article" ||
        this.$route.name === "education_training_and_employment" ||
        this.$route.name === "opportunities_archive" ||
        this.$route.name === "opportunities_article" ||
        this.$route.name === "budget_planner" ||
        this.$route.name === "community" ||
        this.$route.name === "search" ||
        this.$route.name === "contact" ||
        this.$route.name === "toolkit" ||
        this.$route.name === "toolkit_article" ||
        this.$route.name === "toolkit_archive" ||
        this.$route.name === "toolkit_search" ||
        this.$route.name === "education" ||
        this.$route.name === "education_article"
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  border-bottom-right-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
  min-height: 56px;
  height: auto !important;

  &--shape-background {
    box-shadow: none !important;
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;

    @media (min-width: 1024px) {
      border-bottom-right-radius: 20px !important;
      border-bottom-left-radius: 20px !important;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
    }

    .toolbar__content-inner {
      border-bottom-right-radius: 0 !important;
      border-bottom-left-radius: 0 !important;

      @media (min-width: 1024px) {
        display: flex;
        border-bottom-right-radius: 20px !important;
        border-bottom-left-radius: 20px !important;
      }
    }
  }

  &__clip-container {
    position: absolute;
    top: calc(var(--sat) + 55px);
    left: 0;
    width: 100%;
    padding-bottom: 15.9%; /* Aspect ratio: 62 / 390 * 100 */
    z-index: 1;
    filter: drop-shadow(0 2px 5px #000000);

    @media (min-width: 1024px) {
      display: none;
    }
  }

  &__clipped-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #6d72b6;
    clip-path: url(#responsiveClipPath);
    -webkit-clip-path: url(#responsiveClipPath);

    @media (min-width: 1024px) {
      display: none;
    }
  }

  &__content-inner {
    width: 100%;
    background-color: $blue;
    z-index: 2;
    padding-top: var(--sat);
    border-bottom-right-radius: 20px !important;
    border-bottom-left-radius: 20px !important;
  }

  &__inner {
    display: flex;
    align-items: center;
    column-gap: 20px;
    padding: 4px 16px;
    height: 56px;
    width: 100%;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1;
    margin-left: -10px;
    color: $black !important;
  }

  &__btn {
    width: auto !important;
    height: auto !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    border-radius: 3px;

    &::before {
      display: none !important;
    }

    &:focus {
      outline: 2px solid $white !important;
      outline-offset: 6px;
    }
  }

  &__avatar {
    &:focus {
      outline: 2px solid $white !important;
      outline-offset: 6px;
    }
  }

  ::v-deep {
    .v-toolbar__content {
      height: auto !important;
      padding: 0 !important;
    }
  }
}

::v-deep {
  .v-badge__badge {
    font-family: "Balsamiq Sans", sans-serif;
    font-weight: 400;
    line-height: 1;
    font-size: 16px;
  }
}

.navigation {
  &__close {
    position: absolute;
    top: calc(var(--sat) + 10px);
    right: 10px;
    background-color: $blue;
    border-radius: 5px;
    width: 24px;
    height: 24px;

    &:focus {
      outline: 2px solid $black !important;
      outline-offset: 2px;
    }

    @media (min-width: 960px) {
      display: none;
    }
  }

  &__head {
    display: flex;
    align-items: center;
    padding: calc(var(--sat) + 10px) 16px 20px;
    background: $white;
    margin-bottom: 20px;
  }

  &__logo {
    max-width: 140px;
  }

  &__nav-list-item {
    border-radius: 0 !important;

    &:before,
    &:after {
      display: none;
    }

    &--settings {
      padding: 0;
    }

    &--link {
      padding: 0;
    }

    &--language {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      margin-bottom: 30px !important;

      &:after {
        display: none;
      }
    }
  }

  &__nav-item-link {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
    font-size: 1rem !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    color: $black !important;
    text-decoration: none;
    padding: 8px;

    &:focus {
      outline: 2px solid $black !important;
    }
  }

  &__nav-item-title {
    font-size: 1rem !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    color: $black !important;
    text-overflow: unset;
    white-space: unset;

    &--language {
      font-size: 0.875rem !important;
      align-self: flex-start;
      margin-bottom: 5px;
    }
  }
}
</style>
